import { CommandRequest, ListCommand } from '../components/modules/commands/types';
import { DataProps } from '../components/modules/points/types/types';
import { TableCommandResponse } from '../components/ui/commandUI/table';

import { PushClient } from './util/PushClient';

export class CommandsApi extends PushClient {
  static baseUrl = '/SiteCommands';

  private static ongoingGetPointsRequests = new Map<number, Promise<DataProps>>();

  public async getCommands(siteId: number): Promise<ListCommand> {
    const url = `${CommandsApi.baseUrl}/${siteId}`;
    const response = await this.client.get<ListCommand>(url);
    const commandsList = response;

    return commandsList;
  }

  public async runCommand(
    siteId: number,
    request: CommandRequest
  ): Promise<string | TableCommandResponse> {
    const url = `${CommandsApi.baseUrl}/${siteId}`;
    const response = await this.client.post(url, { ...request });

    return response as string;
  }

  public async getPoints(siteId: number, freshValues: boolean): Promise<DataProps> {
    const ongoingRequest = CommandsApi.ongoingGetPointsRequests.get(siteId);
    if (ongoingRequest) {
      // Return the existing promise to prevent duplicate calls
      return ongoingRequest;
    }

    // Create the request promise
    const requestPromise = this.executeGetPointsRequest(siteId, freshValues);

    // Store the promise in the map
    CommandsApi.ongoingGetPointsRequests.set(siteId, requestPromise);

    try {
      const result = await requestPromise;
      return result;
    } finally {
      // Remove the promise from the map when the request completes (success or error)
      CommandsApi.ongoingGetPointsRequests.delete(siteId);
    }
  }

  private async executeGetPointsRequest(siteId: number, freshValues: boolean): Promise<DataProps> {
    const url = `${CommandsApi.baseUrl}/${siteId}/PointThemes?noCache=${freshValues}`;
    const response = await this.client.get<DataProps>(url);
    const themesList = response;

    return themesList;
  }

  public async savePoints(siteId: number, points: DataProps): Promise<void> {
    const url = `${CommandsApi.baseUrl}/${siteId}/Points`;
    await this.client.put(url, points);
  }
}
